import {SortByType} from "./index";
import {ID, intboolean} from "app/types/app-types";
import {ViewTableType} from "../containers";
import { ShowGroupType } from "diagnostics/diagnostics";

export type ElementsFilterType = {
    index: number
    field: string
    value: string
    secondValue?: string
}

export type ProductFilterType = {
    id?: number|string
    template_id: number|string
    image_link: string
    rendered_by: string
    rendered_type: number | string
    url: string
    productName: string
    check_elements_availability?: string[] /*multiselect*/
    has_alt_images?: boolean
    fulltext: string
}

export type ImageFilterType = {
    width?: string[]    /*multiselect*/
    height?: string[]   /*multiselect*/
    object_to_image_ratio?: string
    bg_color?: string[] /*multiselect*/
    bg_color_distance?: number
    color_space?: string[]  /*multiselect*/
    is_light_bg?: string
    has_person?: string
    is_solid_bg?: string
    is_transparent?: string
    error_code: string|number
    status_code: string[] | number[] /*multiselect*/
    content_type: string[]      /*multiselect*/
    content_length: string[]    /*multiselect*/
    showGroup: ShowGroupType[]  /*multiselect*/
    orientation?: 'portrait' | 'landscape' | 'square' | null
    should_redownload?: intboolean
}

export type RangeType = {
    from: string|number
    to: string|number
}

export type ImageValidationsFilterType = {
    mistake_set_by_user: intboolean
    correctness_percentage_offset: RangeType
    has_alpha: intboolean
    object_position: number[]   /*multiselect*/
    status: string[]            /*multiselect*/
    status_reason: string[]     /*multiselect*/
    image_id: ID
}

export type WatermarkFilterType = {
    user_set: 0|-1|1|string
    user_set_objects: 1 | 0 | null  //has user set objects?
    confidence: RangeType
    status: string[]
    status_reason: string[]
    image_id: ID
}

export type QualityFilterType = {
    user_set: 0 | 1 | -1 | string
    confidence: RangeType
    status: string[]
    status_reason: string[]
    image_id: ID
}

export type PersonFilterType = {
    max_confidence: RangeType
    status: string[]
    status_reason: string[]
    image_id: ID
}

export type FiltersFormType = {
    product: ProductFilterType
    image: ImageFilterType
    elements: ElementsFilterType[]
    image_validations: ImageValidationsFilterType
    watermark: WatermarkFilterType
    quality: QualityFilterType
    person: PersonFilterType
    mergadoids: number[]
    paginator: number
    productsPerPage: number
    groupByImage: boolean
    sortBy: SortByType
    viewTable: ViewTableType
}

export const emptyRangeState: RangeType = {
    from: null,
    to: null,
}

export const emptyFiltersState : FiltersFormType = {
    product: {
        template_id: null,
        image_link: null,
        rendered_by: null,
        rendered_type: null,
        url: null,
        productName: null,
        fulltext: null,
    },
    image: {
        error_code: null,
        status_code: [],
        content_type: [],
        content_length: [],
        bg_color: [],
        bg_color_distance: null,
        color_space: [],
        is_light_bg: null,
        is_solid_bg: null,
        is_transparent: null,
        showGroup: null
    },
    image_validations: {
        mistake_set_by_user: null,
        correctness_percentage_offset: emptyRangeState,
        has_alpha: null,
        image_id: null,
        status: [],
        status_reason: [],
        object_position: [],
    },
    watermark: {
        user_set: null,
        user_set_objects: null,        //has objects defined?
        confidence: emptyRangeState,
        status: [],
        status_reason: [],
        image_id: null,
    },
    quality: {
        user_set: null,
        confidence: emptyRangeState,
        status: [],
        status_reason: [],
        image_id: null,
    },
    person: {
        max_confidence: emptyRangeState,
        status: [],
        status_reason: [],
        image_id: null,
    },
    mergadoids: [],
    paginator: 1,
    productsPerPage: 10,
    groupByImage: false,
    sortBy: null,
    elements: [],
    viewTable: "products"
}

